module.exports = __webpack_public_path__ + "6b1fdcf1c7264410f713598ca4b04f19.MP3";